export const Footer = () => {
  return (
    <footer className=" text-dark py-5 mt-5">
      <div className="container text-center">
        <p className=" mt-5">
          This porject is designed and coded by{" "}
          <a
            href="https://github.com/punSavitri"
            title="GitHub Repo Link"
            target="_blank"
            rel="noreferrer"
          >
            Savitri Pun
          </a>{" "}
          and{" "}
          <a
            href="https://github.com/punSavitri/react-counter-progress-bar.git"
            title="Link to Github project repo"
            target="_blank"
            rel="noreferrer"
          >
            is a open sourced on GitHub
          </a>
          and{" "}
          <a
            href="#"
            title="Hostinger Link to the project"
            target="_blank"
            rel="noreferrer"
          >
            hosted on Hostinger
          </a>
        </p>
      </div>
    </footer>
  );
};
